import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm$selectedTemplate, _vm$getAccountById, _vm$selectedTemplate2, _vm$selectedTemplate3;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('CoreHeader', {
    attrs: {
      "headline": _vm.$i18n_t('DigitalTwin.Templates.title'),
      "subtitle": _vm.$i18n_t('DigitalTwin.Templates.subTitle'),
      "show-beta-badge": true
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('CoreButton', {
          attrs: {
            "data-cy": "btn_create_dtwin_template",
            "color": _vm.color,
            "prepend-icon": "fa-plus"
          },
          on: {
            "click": _vm.handleShowDialogCreate
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.create')) + "\n      ")]), _c('CoreAccountFilter', {
          attrs: {
            "data-cy": "account_filter",
            "multiple": ""
          },
          on: {
            "change": _vm.handleAccountFilterChange,
            "ready": _vm.handleAccountFilterReady
          }
        })];
      },
      proxy: true
    }])
  }), _vm.showDialogCreate ? _c('DigitalTwinTemplateCreateDialog', {
    attrs: {
      "accounts": _vm.setSelectedAccounts
    },
    on: {
      "close": _vm.handleCloseDialogCreate,
      "save": _vm.handleSaveDialogCreate
    }
  }) : _vm._e(), _c(VContainer, {
    staticClass: "pa-0 px-3 n20-container",
    attrs: {
      "fluid": "",
      "data-cy": "dtwin_templates_container"
    }
  }, [_vm.isEmpty ? _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pa-0"
  }, [_c('CoreN20Card', [_vm.accountFilterIsReady ? [_c('EmptyState', {
    attrs: {
      "color": _vm.color,
      "icon": "fa-sitemap",
      "data-cy": "empty_state_dtwin_templates"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.Templates.emptyState.title')) + "\n              ")];
      },
      proxy: true
    }, {
      key: "button",
      fn: function () {
        return [_c('CoreButton', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "append-icon": "fa-arrow-right",
            "data-cy": "btn_create_dtwin_template_empty_state"
          },
          on: {
            "click": _vm.handleShowDialogCreate
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.Templates.emptyState.button')) + "\n                ")])];
      },
      proxy: true
    }], null, false, 2005918815)
  }, [_c('p', [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.Templates.emptyState.description')) + "\n              ")])])] : _vm._e()], 2)], 1)], 1) : _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-0 pl-0 two-cols-dynamic-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('CoreN20Card', [_c(VTreeview, {
    staticStyle: {
      "max-height": "530px",
      "overflow-y": "auto"
    },
    attrs: {
      "item-key": "id",
      "expand-icon": "fal fa-angle-down",
      "items": _vm.templates,
      "open": _vm.openNodes,
      "active": _vm.activeNodes,
      "color": _vm.color,
      "load-children": _vm.loadChildren,
      "activatable": "",
      "return-object": ""
    },
    on: {
      "update:open": function ($event) {
        _vm.openNodes = $event;
      },
      "update:active": [function ($event) {
        _vm.activeNodes = $event;
      }, _vm.handleActiveUpdate]
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [_c('span', {
          staticStyle: {
            "cursor": "pointer",
            "color": "inherit"
          }
        }, [_vm._v(_vm._s(item.title))])];
      }
    }])
  })], 1)], 1), _c(VCol, {
    staticClass: "py-0 pr-0 two-cols-dynamic-2",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('CoreN20Card', [_c('h3', [_vm._v(_vm._s((_vm$selectedTemplate = _vm.selectedTemplate) === null || _vm$selectedTemplate === void 0 ? void 0 : _vm$selectedTemplate.title))]), _c('p', [_vm._v("Account: " + _vm._s((_vm$getAccountById = _vm.getAccountById((_vm$selectedTemplate2 = _vm.selectedTemplate) === null || _vm$selectedTemplate2 === void 0 ? void 0 : _vm$selectedTemplate2.tenantId)) === null || _vm$getAccountById === void 0 ? void 0 : _vm$getAccountById.name))]), _c('hr', {
    staticClass: "mt-4 mb-4"
  }), _c('pre', [_vm._v(_vm._s(_vm.selectedTemplate))]), _c('hr', {
    staticClass: "mt-4 mb-4"
  }), _c('p', [_vm._v("Updated: " + _vm._s(_vm.formatDateTime((_vm$selectedTemplate3 = _vm.selectedTemplate) === null || _vm$selectedTemplate3 === void 0 ? void 0 : _vm$selectedTemplate3.updatedAt)))])])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };